import { ValidationResult } from '../../../../../../../../../../../ui/gzForm/formField/types/form-validator';
import { translateFn } from '../../../../../../../../../../../utils/translator.helper';
import {
  AntimalwareOnDemandExclusionTask,
  AntimalwareOnDemandExclusionTaskType,
} from '@nirvana/shared/dtos/types/policies/common';
import { universalAbsolutePath } from '../../../../../../../../../../common/policyPanel/uiSettings/utils/validators/path.validators';
import { extension } from '../../../../../../../../../../common/policyPanel/uiSettings/utils/validators/extension.validators';

export async function validatePathByType(
  type: AntimalwareOnDemandExclusionTaskType,
  entity: string
): Promise<ValidationResult> {
  if (type !== AntimalwareOnDemandExclusionTaskType.EXTENSION) {
    return await universalAbsolutePath(entity);
  }

  return await extension(entity);
}

// validate duplicates
export function validateDuplicates(
  item: AntimalwareOnDemandExclusionTask,
  itemsInGrid: AntimalwareOnDemandExclusionTask[]
): ValidationResult {
  const hasDuplicates = itemsInGrid.some(
    (itemInGrid: AntimalwareOnDemandExclusionTask) => itemInGrid.path === item.path
  );

  if (hasDuplicates) {
    return {
      valid: false,
      error: translateFn('The entry already exists.'),
    };
  }

  return {
    valid: true,
  };
}
